import styled from 'styled-components';

export const TabsContainer = styled.div`
  .segment.active.tab {
    min-height: auto;
  }
`;
